import { get } from 'lodash';
import { AxiosClient } from 'src/configs/axios/axios';

const CASE_STUDY_API = {
  listCaseStudiesAPI: async (params: Study.GetStudiesParams) => {
    const response = await new AxiosClient().get('/case-studies', { params })
    return get(response, 'data', null)
  },
  createCaseStudiesAPI: async (params: Study.StudiesPostDetailParams) => {
    const response = await new AxiosClient().post('/case-studies', params)
    const data = get(response, 'data', null)
    return data
  },
  updateCaseStudiesAPI: async (params: Study.StudiesPostDetailParams) => {
    const response = await new AxiosClient().put(
      `/case-studies/${params.id}`,
      params
    )
    const data = get(response, 'data', null)
    return data
  },
  deleteCaseStudyAPI: async (id: string) => {
    const response = await new AxiosClient().delete('/case-studies/' + id)
    const data = get(response, 'data', null)
    return data
  },
}

export default CASE_STUDY_API
